import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API from '../../config/api';

export function usePrasadShipping({ enabled, ready, pincode, subtotal, cod }) {
  const [quote, setQuote] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const key = enabled && ready ? JSON.stringify([pincode.trim(), subtotal, cod, attempt]) : '';

  useEffect(() => {
    setQuote(null);
    setSelectedId(null);
    if (!key) return;
    let cancelled = false;
    const [pin, total, cashOnDelivery] = JSON.parse(key);
    const timeout = setTimeout(async () => {
      try {
        const { data } = await axios.post(`${API}/shipping/serviceability`, {
          pincode: pin, weight: 0.5, subtotal: total, cod: cashOnDelivery ? 1 : 0,
        });
        const packages = data.serviceable === false ? [] : (data.packages || []).filter(
          option => option.id && option.rate !== null && option.rate !== '' && Number.isFinite(Number(option.rate)) && Number(option.rate) >= 0
        ).map(option => ({ ...option, rate: Number(option.rate) }));
        if (!cancelled) setQuote({ key, packages, estimated: data.is_live_api === false,
          message: packages.length ? '' : (data.message || 'No delivery options are available for this PIN code.') });
      } catch {
        if (!cancelled) setQuote({ key, packages: [], message: 'Unable to load delivery options. Please retry.' });
      }
    }, 350);
    return () => { cancelled = true; clearTimeout(timeout); };
  }, [key]);

  const current = key && quote?.key === key ? quote : null;
  return {
    ready: Boolean(key), loading: Boolean(key && !current), options: current?.packages || [],
    selected: current?.packages.find(option => option.id === selectedId) || null,
    estimated: current?.estimated, message: current?.message,
    select: setSelectedId, retry: () => setAttempt(value => value + 1),
  };
}

export default function PrasadShipping({ shipping }) {
  return (
    <fieldset className="mt-4 space-y-2" data-testid="prasad-shipping">
      <legend className="text-sm font-bold text-[#4E1225]">Prasad Shipping Options</legend>
      {!shipping.ready ? <p className="text-xs text-gray-500">Complete your contact, devotee and delivery details to see shipping options.</p>
        : shipping.loading ? <p role="status" className="text-xs text-gray-500">Checking delivery options…</p>
        : shipping.message ? <div role="alert" className="text-xs text-red-700">
          <p>{shipping.message}</p>
          <button type="button" onClick={shipping.retry} className="mt-2 underline">Retry delivery options</button>
        </div> : <>
          {shipping.estimated && <p className="text-xs text-gray-500">Estimated options from the store shipping service; live courier rates are currently unavailable.</p>}
          {shipping.options.map(option => (
            <label key={option.id} className="flex items-start gap-3 rounded-xl border border-[#E7D9BC] bg-white p-3 cursor-pointer">
              <input type="radio" name="prasad-shipping" value={option.id}
                checked={shipping.selected?.id === option.id} onChange={() => shipping.select(option.id)}
                className="mt-1 accent-[#6E1B34]" />
              <span className="min-w-0 flex-1 text-xs">
                <span className="block font-bold text-[#4E1225]">{option.name}</span>
                <span className="block text-gray-500">{option.courier_name}</span>
                {option.etd && <span className="block text-gray-500">Transit after dispatch: {option.etd}</span>}
              </span>
              <span className="shrink-0 text-xs font-bold text-[#6E1B34]">{option.rate === 0 ? 'Free' : `₹${option.rate}`}</span>
            </label>
          ))}
        </>}
    </fieldset>
  );
}
